module.exports = __webpack_public_path__ + "img/teacher-unlight.3c34e8c4.png";